import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import type { FetchWorkerBlocksAction } from './actions'

/**
 * GET /api/v2/workers/:id/blocks. `handleCall` keeps the request payload on the
 * envelope so `entityReducer` can key the paginated set by `{ workerID, ...query }`.
 */
export const fetchWorkerBlocks = ({ payload }: FetchWorkerBlocksAction) =>
  new Promise((resolve, reject) => {
    handleCall(
      apiRequest({
        path: `/workers/${payload.workerID}/blocks`,
        reqArgs: payload,
      }),
      resolve,
      reject,
      true,
      payload,
    )
  })
